import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { RootState } from "./state";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
  ],
  state: {
    allFormValues: {},
    userEmail: "",
    myJLSToken: "",
    userName: "",
    bankName: "",
  },
  actions,
  mutations,
  getters,
};

export default new Vuex.Store<RootState>(store);
